function waitForAxios(timeout = 10000) {
  const startTime = Date.now();

  return new Promise((resolve, reject) => {
    function checkAxios() {
      if (window.axios !== undefined) {
        resolve(window.axios);
        return;
      }
      if (Date.now() - startTime > timeout) {
        reject(new Error("Timeout waiting for axios to load"));
        return;
      }
      setTimeout(checkAxios, 100);
    }
    checkAxios();
  });
}

waitForAxios().then(() => {
  const HOST = window.theme.host;
  const headers = { shop: window.theme.shop };
  const mainSpinner = document.querySelector(".gallerySpinnerMain");
  const contentSpinner = document.querySelector(".gallerySpinnerContent");
  const mainContainer = document.querySelector(".gallery-container");
  const listingsContainer = document.querySelector(
    ".GalleryListings__container"
  );
  const paginationMeta = document.querySelector(".PaginationMeta");
  const paginationConatiner = document.querySelector(".PaginationContainer");
  const limit = 15;

  const deparam = () => {
    let queryString = {};
    let uri = window.location.search;
    uri.replace(
      new RegExp("([^?=&]+)(=([^&#]*))?", "g"),
      ($0, $1, $2, $3) => (queryString[$1] = decodeURIComponent($3))
    );
    return queryString;
  };

  const options = {
    make: deparam().make ? deparam().make : "",
    series: deparam().series ? deparam().series : "",
    chassis: deparam().chassis ? deparam().chassis : "",
    page: deparam().page ? parseInt(deparam().page) : 1,
    vendors: deparam().vendors ? deparam().vendors.split(",") : [],
  };

  const getFilters = async () => {
    try {
      const facetContainers = document.querySelectorAll(".carFilterFacets");
      const modBrandFacetContainers =
        document.querySelectorAll(".modVendorFacets");
      const response = await axios.get(`${HOST}/filters`, { headers });
      const filters = sortFilterArrAlpha(response.data.galleryFilters);
      const modBrandFilters = sortFilterArrAlpha(response.data.modBrandFilters);

      document
        .querySelectorAll(".galleryFilterButton")
        .forEach((btn) => btn.addEventListener("click", filterClick));
      facetContainers.forEach((container) => {
        filters.forEach((makeFilter) => {
          const button = document.createElement("button");
          const textSpan = document.createElement("span");
          const countSpan = document.createElement("span");
          const seriesContainer = document.createElement("div");
          button.classList =
            "galleryFilterButton findify-components--button findify-components--category-facet__item";
          textSpan.classList =
            "findify-components--text findify-components--text__primary-lowercase";
          countSpan.classList =
            "findify-components--text findify-components--text__secondary-uppercase";
          seriesContainer.classList =
            "nestedCarFilters  findify-components--category-facet__nested";
          button.setAttribute("data-value", makeFilter.value);
          button.setAttribute("data-filter-type", "make");
          button.addEventListener("click", filterClick);
          textSpan.textContent = makeFilter.value;
          countSpan.textContent = `(${makeFilter.count})`;
          button.append(textSpan);
          button.append(countSpan);
          container.append(button);
          container.append(seriesContainer);
          const seriesFilters = sortFilterArrAlpha(makeFilter.series);
          seriesFilters.forEach((seriesFilter) => {
            if (seriesFilter.count > 0) {
              const seriesButton = document.createElement("button");
              const seriesTextSpan = document.createElement("span");
              const seriesCountSpan = document.createElement("span");
              const chassisContainer = document.createElement("div");
              seriesButton.classList =
                "galleryFilterButton findify-components--button findify-components--category-facet__item";
              seriesTextSpan.classList =
                'findify-components--text findify-components--text__primary-lowercase findify-components--category-facet__content"';
              seriesCountSpan.classList =
                "findify-components--text findify-components--text__secondary-uppercase";
              chassisContainer.classList =
                "nestedCarFilters findify-components--category-facet__nested";
              seriesButton.setAttribute("data-value", seriesFilter.value);
              seriesButton.setAttribute("data-filter-type", "series");
              seriesButton.addEventListener("click", filterClick);
              seriesTextSpan.textContent = seriesFilter.value;
              seriesCountSpan.textContent = `(${seriesFilter.count})`;
              seriesButton.append(seriesTextSpan);
              seriesButton.append(seriesCountSpan);
              seriesContainer.append(seriesButton);
              seriesContainer.append(chassisContainer);
              const chassisFilters = sortFilterArrAlpha(seriesFilter.chassis);
              chassisFilters.forEach((chassisFilter) => {
                if (chassisFilter.count > 0) {
                  const chassisButton = document.createElement("button");
                  const chassisTextSpan = document.createElement("span");
                  const chassisCountSpan = document.createElement("span");
                  chassisButton.classList =
                    "galleryFilterButton findify-components--button findify-components--category-facet__item";
                  chassisTextSpan.classList =
                    'findify-components--text findify-components--text__primary-lowercase findify-components--category-facet__content"';
                  chassisCountSpan.classList =
                    "findify-components--text findify-components--text__secondary-uppercase";
                  chassisButton.setAttribute("data-value", chassisFilter.value);
                  chassisButton.setAttribute("data-filter-type", "chassis");
                  chassisButton.addEventListener("click", filterClick);
                  chassisTextSpan.textContent = chassisFilter.value;
                  chassisCountSpan.textContent = `(${chassisFilter.count})`;
                  chassisButton.append(chassisTextSpan);
                  chassisButton.append(chassisCountSpan);
                  chassisContainer.append(chassisButton);
                }
              });
            }
          });
        });
      });

      modBrandFacetContainers.forEach((container) => {
        modBrandFilters.forEach((modFilter) => {
          if (modFilter.value.length < 20) {
            const button = document.createElement("button");
            button.classList =
              "findify-components--button findify-components--checkbox-facet__item modFilterButton";
            button.setAttribute("data-vendor-value", modFilter.value);
            button.addEventListener("click", modFilterClick);
            button.innerHTML = `
            <svg width="12" height="12" class="findify-components--icon notSelected" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h12v12H0V0zm1 1v10h10V1H1z" fill="currentColor" fill-rule="evenodd"></path></svg>
            <svg width="12" height="12" class="findify-components--icon isSelected" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fill-rule="evenodd"><path d="M4.248 8.188L10.422 2l.826.826-7 7L1 6.578l.812-.826z"></path><path d="M0 0h12v12H0V0zm1 1v10h10V1H1z"></path></g></svg>
            <span class="test findify-components--text findify-components--text__primary-lowercase findify-components--checkbox-facet__content">${modFilter.value}</span>
            <span class="test findify-components--text findify-components--text__secondary-uppercase">(${modFilter.count})</span>
          `;
            container.append(button);
          }
        });
        if (modBrandFilters.length > 6) {
          const button = document.createElement("button");
          button.className =
            "findify-components--button findify-components--checkbox-facet__expand expandBtn more";
          button.innerHTML =
            '<div class="lessTxt"><span class="findify-components--text findify-components--text__primary-uppercase"><svg width="15" height="15" class="findify-components--icon" xmlns="http://www.w3.org/2000/svg"><path d="M3 7h9v1H3z" fill="currentColor" fill-rule="evenodd"></path></svg>Less</span></div>    <div class="moreTxt"><span class="findify-components--text findify-components--text__primary-uppercase"><svg width="15" height="15" class="findify-components--icon" xmlns="http://www.w3.org/2000/svg"><path d="M8 7V3H7v4H3v1h4v4h1V8h4V7H8z" fill="currentColor" fill-rule="evenodd"></path></svg>More</span></div>';
          button.addEventListener("click", (e) => {
            if (e.currentTarget.classList.contains("more")) {
              document
                .querySelectorAll(".expandBtn")
                .forEach((b) => b.classList.remove("more"));
              document
                .querySelectorAll(".modVendorFacets")
                .forEach((l) => l.classList.add("scroll"));
            } else {
              document
                .querySelectorAll(".expandBtn")
                .forEach((b) => b.classList.add("more"));
              document.querySelectorAll(".modVendorFacets").forEach((l) => {
                l.scrollTop = 0;
                l.classList.remove("scroll");
              });
            }
          });
          container
            .closest(".findify-components-search--desktop-facets__facet")
            .append(button);
        }
      });

      const totalCount = filters.reduce((total, { count }) => total + count, 0);
      document
        .querySelectorAll(".allCarCount")
        .forEach((container) => (container.textContent = `(${totalCount})`));

      if (options.make) {
        setFilterClasses("make");
        if (options.series) {
          setFilterClasses("series");
          if (options.chassis) {
            setFilterClasses("chassis");
          }
        }
      }

      setModFilterClasses();
      setFilterBreadcrumbs();
      mainSpinner.classList.remove("active");
      mainContainer.style.display = "block";
      getListings();
    } catch (e) {
      console.log("Error getting filters", e);
    }
  };

  const sortFilterArrAlpha = (arr) =>
    arr.sort((a, b) => {
      const textA = a.value;
      const textB = b.value;
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

  const getListings = async () => {
    try {
      listingsContainer.style.display = "none";
      contentSpinner.classList.add("active");

      let url = `${HOST}/gallery_listings?page=${options.page}`;
      if (options.make) {
        url += `&make=${encodeURIComponent(options.make)}`;
        if (options.series) {
          url += `&series=${encodeURIComponent(options.series)}`;
          if (options.chassis) {
            url += `&chassis=${encodeURIComponent(options.chassis)}`;
          }
        }
      }

      if (options.vendors.length > 0) {
        url += `&vendors=${options.vendors.join(",")}`;
      }

      const response = await axios.get(url, { headers });

      buildGrid(response.data.listings);
      buildPagination(response.data.count);
      // console.log('listings ', response.data.listings);

      contentSpinner.classList.remove("active");
      listingsContainer.style.display = "grid";
    } catch (e) {
      console.log("Error getting listings", e);
    }
  };

  const buildGrid = (listings) => {
    listingsContainer.innerHTML = "";
    // console.log("Building grid");
    let lastItem = {
      selectedCar: "na",
      model: "na",
      year: "na",
      make: "na",
      series: "na",
      images: [],
    };
    let listCount = 1;
    let listSchema = `
    {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
  `;
    listings.forEach((listing) => {
      // console.log('listing ', listing);
      // console.log('Inspecting listing:', listing);
      try {
        let currentItem = {
          selectedCar: listing.selectedCar,
          model: listing.model,
          year: listing.year,
          // images: listing.images
        };
        let selectedCheck =
          lastItem.selectedCar.toString() == listing.selectedCar.toString()
            ? "true"
            : "false";
        let modelCheck =
          lastItem.model.toString() == listing.model.toString()
            ? "true"
            : "false";
        let makeCheck =
          (lastItem.make ? lastItem.make.toString() : "na") ==
          (listing.make ? listing.make.toString() : "na")
            ? "true"
            : "false";
        let seriesCheck =
          (lastItem.series ? lastItem.series.toString() : "na") ==
          (listing.series ? listing.series.toString() : "na")
            ? "true"
            : "false";
        let yearCheck =
          lastItem.year.toString() == listing.year.toString()
            ? "true"
            : "false";
        let engineModsCheck =
          lastItem.engineMods?.toString() == listing.engineMods?.toString()
            ? "true"
            : "false";
        let tireBrandCheck =
          lastItem.tireBrandOrModel?.toString() ==
          listing.tireBrandOrModel?.toString()
            ? "true"
            : "false";
        let wheelBrandCheck =
          lastItem.wheelBrandOrModel?.toString() ==
          listing.wheelBrandOrModel?.toString()
            ? "true"
            : "false";
        let imagesCheck =
          lastItem.images?.toString() == listing.images?.toString()
            ? "true"
            : "false";
        let arrayOfChecks = [
          selectedCheck,
          modelCheck,
          yearCheck,
          engineModsCheck,
          tireBrandCheck,
          wheelBrandCheck,
          imagesCheck,
        ];
        // console.log('checks', arrayOfChecks);

        if (imagesCheck.includes("false")) {
          const div = document.createElement("div");
          let fallbackBodyIdentifier = listing.series;
          if (listing.series.includes(":R")) {
            fallbackBodyIdentifier = listing.chassis.split("(")[0];
          }
          let schemaHeadline = `${listing.year} ${transformMake(
            listing.make
          )} ${
            transformModel(listing)
              ? transformModel(listing)
              : fallbackBodyIdentifier
          }`;
          let schemaDescription = "";
          let schemaImage = listing.images[0];

          // console.log('Alt Schema ', listing, schemaHeadline, schemaDescription, schemaImage);
          div.innerHTML = `
          <a href="/pages/${slugify(listing.selectedCar)}-${
            listing._id
          }" class="Listing loading-in">
            <div class="Listing__container">
              <div class="Listing__header">            
                <h3>${listing.year} ${transformMake(listing.make)} ${
            transformModel(listing)
              ? transformModel(listing)
              : fallbackBodyIdentifier
          }</h3>
              </div>
              <div class="Listing__image" data-img-src-set="${
                listing.images[0]
              }">
                <div class="Listing__spinner"> <div class="lds-ring"><div></div><div></div><div></div><div></div></div> </div>
                <img src="${HOST}/image/thumb_${
            listing.images[0].split("/image/")[1]
          }"/>
              </div>
            </div>
          </a>
        `;
          listSchema += `
        {
          "@type": "ListItem",
          "position": "${listCount}",
          "url": "/pages/${slugify(listing.selectedCar)}-${listing._id}",
          "name": "${listing.year} ${transformMake(listing.make)} ${
            transformModel(listing)
              ? transformModel(listing)
              : fallbackBodyIdentifier
          }"
          },
        `;
          div.querySelector("img").onload = () =>
            div.querySelector(".Listing__image").classList.add("loaded");
          listCount++;
          listingsContainer.append(div);
          lastItem = {
            selectedCar: listing.selectedCar,
            model: listing.model,
            year: listing.year,
            images: listing.images,
          };
        } else {
          // console.log('these listings match ', lastItem, listing);
        }
      } catch (error) {
        console.log("error building listing ", error);
      }
    });
    listSchema += `]}`;

    // let schemaScript = document.createElement("script");
    // schemaScript.innerHTML = listSchema;
    // schemaScript.setAttribute("type", "application/ld+json");
    // document.body.appendChild(schemaScript);

    // console.log("schemaScript ", schemaScript);
  };

  const buildPagination = (count) => {
    paginationMeta.innerHTML = "";
    paginationConatiner.innerHTML = "";
    const pages = Math.ceil(count / limit);
    const activePage = options.page;
    if (activePage > 1) {
      const backButton = document.createElement("button");
      backButton.setAttribute("data-page", activePage - 1);
      backButton.className =
        "findify-components--button findify-components--pagination__prev";
      backButton.textContent = "Previous";
      backButton.addEventListener("click", paginationClick);
      paginationConatiner.append(backButton);
    }
    if (activePage > 3) {
      const firstLink = document.createElement("button");
      const dots = document.createElement("button");
      firstLink.setAttribute("data-page", 1);
      firstLink.className =
        "findify-components--button findify-components--pagination__first";
      dots.className =
        "findify-components--button findify-components--pagination__dots";
      firstLink.textContent = "1";
      dots.textContent = "...";
      firstLink.addEventListener("click", paginationClick);
      paginationConatiner.append(firstLink);
      paginationConatiner.append(dots);
    }
    for (let i = 1; i <= pages; i++) {
      if (i > activePage - 3 && i < activePage + 3) {
        const button = document.createElement("button");
        button.setAttribute("data-page", i);
        button.className =
          "findify-components--button findify-components--pagination__page";
        if (i === activePage) {
          button.classList.add("findify-components--pagination__active");
        }
        button.textContent = i;
        button.addEventListener("click", paginationClick);
        paginationConatiner.append(button);
      }
    }
    if (activePage < pages - 2) {
      const lastLink = document.createElement("button");
      const dots = document.createElement("button");
      lastLink.setAttribute("data-page", pages);
      lastLink.className =
        "findify-components--button findify-components--pagination__last";
      dots.className =
        "findify-components--button findify-components--pagination__dots";
      lastLink.textContent = pages;
      dots.textContent = "...";
      lastLink.addEventListener("click", paginationClick);
      paginationConatiner.append(dots);
      paginationConatiner.append(lastLink);
    }
    if (activePage !== pages) {
      const nextButton = document.createElement("button");
      nextButton.setAttribute("data-page", activePage + 1);
      nextButton.className =
        "findify-components--button findify-components--pagination__next";
      nextButton.textContent = "Next";
      nextButton.addEventListener("click", paginationClick);
      paginationConatiner.append(nextButton);
    }

    paginationMeta.textContent = `Showing: ${
      limit * options.page - (limit - 1)
    } - ${
      count > limit * options.page ? limit * options.page : count
    } of ${count}`;
  };

  const filterClick = (e) => {
    const value = e.currentTarget.dataset.value;
    const filterType = e.currentTarget.dataset.filterType;

    if (filterType === "all") {
      options.make = "";
      options.series = "";
      options.chassis = "";
    } else if (filterType === "make") {
      options.make = value;
      options.series = "";
      options.chassis = "";
    } else if (filterType === "series") {
      options.series = value;
      options.chassis = "";
    } else if (filterType === "chassis") {
      options.chassis = value;
    }

    options.page = 1;

    setFilterClasses(filterType);
    setFilterBreadcrumbs();
    pushToHistory();
    getListings();
  };

  const modFilterClick = (e) => {
    const value = e.currentTarget.dataset.vendorValue;
    const index = options.vendors.indexOf(value);
    if (index > -1) {
      options.vendors.splice(index, 1);
    } else {
      options.vendors.push(value);
    }

    options.page = 1;

    setModFilterClasses();
    pushToHistory();
    getListings();
  };

  const setFilterClasses = (filterType) => {
    const { make, series, chassis } = options;

    if (filterType === "all") {
      document
        .querySelectorAll(".galleryFilterButton")
        .forEach((btn) => btn.classList.remove("selected"));
      document
        .querySelectorAll(".nestedCarFilters")
        .forEach((list) => (list.style.height = 0));
      document
        .querySelectorAll('.galleryFilterButton[data-filter-type="all"]')
        .forEach((btn) => btn.classList.add("selected"));
      return;
    } else {
      document
        .querySelectorAll('.galleryFilterButton[data-filter-type="all"]')
        .forEach((btn) => btn.classList.remove("selected"));
    }

    if (filterType === "make") {
      document
        .querySelectorAll(".galleryFilterButton")
        .forEach((btn) => btn.classList.remove("selected"));
      document
        .querySelectorAll(".nestedCarFilters")
        .forEach((list) => (list.style.height = 0));
      const activeButtons = document.querySelectorAll(
        `.galleryFilterButton[data-filter-type="make"][data-value="${make}"]`
      );
      activeButtons.forEach((btn) => {
        btn.classList.add("selected");
        btn.nextSibling.style.height = "auto";
      });
    }

    if (filterType === "series") {
      document
        .querySelectorAll(
          '.galleryFilterButton[data-filter-type="series"], .galleryFilterButton[data-filter-type="chassis"]'
        )
        .forEach((btn) => btn.classList.remove("selected"));
      document
        .querySelectorAll('.galleryFilterButton[data-filter-type="series"]')
        .forEach((btn) => (btn.nextSibling.style.height = 0));
      document
        .querySelectorAll(
          `.galleryFilterButton[data-filter-type="series"][data-value="${series}"]`
        )
        .forEach((btn) => {
          btn.classList.add("selected");
          btn.nextSibling.style.height = "auto";
        });
    }

    if (filterType === "chassis") {
      document
        .querySelectorAll('.galleryFilterButton[data-filter-type="chassis"]')
        .forEach((btn) => btn.classList.remove("selected"));
      document
        .querySelectorAll(
          `.galleryFilterButton[data-filter-type="chassis"][data-value="${chassis}"]`
        )
        .forEach((btn) => btn.classList.add("selected"));
    }
  };

  const setModFilterClasses = () => {
    const vendorCountContainer = document.querySelectorAll(
      ".selectedFilterCount"
    );

    if (options.vendors.length > 0) {
      vendorCountContainer.forEach(
        (v) => (v.textContent = `(${options.vendors.length})`)
      );
    } else {
      vendorCountContainer.forEach((v) => (v.textContent = ""));
    }

    document.querySelectorAll(".modFilterButton").forEach((btn) => {
      const value = btn.dataset.vendorValue;
      if (options.vendors.indexOf(value) > -1) {
        btn.classList.add("selected");
      } else {
        btn.classList.remove("selected");
      }
    });
  };

  const setFilterBreadcrumbs = () => {
    const bcContainer = document.querySelector(".breadcrumb.hidden-xs");
    if (!bcContainer) return;
    let bcString = '<a href="/pages/gallery">Gallery</a>';
    if (options.make) {
      bcString += '<span class="nextArr">></span>';
      bcString += `<a>${options.make}</a>`;
      if (options.series) {
        bcString += '<span class="nextArr">></span>';
        bcString += `<a>${options.series}</a>`;
        if (options.chassis) {
          bcString += '<span class="nextArr">></span>';
          bcString += `<a>${options.chassis}</a>`;
        }
      }
    }
    bcContainer.innerHTML = bcString;
  };

  const paginationClick = (e) => {
    options.page = parseInt(e.currentTarget.dataset.page);
    pushToHistory();
    getListings();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const pushToHistory = () => {
    const historyArr = [`page=${options.page}`];
    const state = { page: options.page };

    if (options.make) {
      historyArr.push(`make=${options.make}`);
      state.make = options.make;
      if (options.series) {
        historyArr.push(`series=${options.series}`);
        state.series = options.series;
        if (options.chassis) {
          historyArr.push(`chassis=${options.chassis}`);
          state.chassis = options.chassis;
        }
      }
    }

    if (options.vendors.length > 0) {
      historyArr.push(`&vendors=${options.vendors.join(",")}`);
      state.vendors = options.vendors;
    }

    history.pushState(state, "gallery", "?" + historyArr.join("&"));
  };

  window.addEventListener("popstate", (e) => {
    if (e.state) {
      options.make = e.state.make ? e.state.make : "";
      options.series = e.state.series ? e.state.series : "";
      options.chassis = e.state.chassis ? e.state.chassis : "";
      options.page = e.state.page ? parseInt(e.state.page) : 1;
      options.vendors = e.state.vendors ? e.state.vendors : [];
    } else {
      options.make = deparam().make ? deparam().make : "";
      options.series = deparam().series ? deparam().series : "";
      options.chassis = deparam().chassis ? deparam().chassis : "";
      options.page = deparam().page ? parseInt(deparam().page) : 1;
      options.vendors = deparam().vendors ? deparam().vendors.split(",") : [];
    }

    if (options.make) {
      setFilterClasses("make");
      if (options.series) {
        setFilterClasses("series");
        if (options.chassis) {
          setFilterClasses("chassis");
        }
      }
    } else {
      setFilterClasses("all");
    }
    setModFilterClasses();
    getListings();
  });

  getFilters();

  const drawer = document.querySelector(
    ".findify-components-common--drawer__content"
  );
  const overlay = document.querySelector(
    ".findify-components-common--drawer__backdrop"
  );
  document
    .querySelectorAll(".carFiltersOverlay, .closeMobileFilters")
    .forEach((btn) =>
      btn.addEventListener("click", () => {
        drawer.classList.remove("open");
        overlay.classList.remove("open");
      })
    );

  document.querySelector(".openMobileFilters").addEventListener("click", () => {
    drawer.classList.add("open");
    overlay.classList.add("open");
  });

  document.querySelectorAll(".modVendorFilterTitle").forEach((btn) =>
    btn.addEventListener("click", (e) => {
      if (e.currentTarget.classList.contains("open")) {
        document
          .querySelectorAll(".modVendorFilterTitle")
          .forEach((b) => b.classList.remove("open"));
        document
          .querySelectorAll(".modVendorFacets")
          .forEach((l) => l.classList.remove("open"));
        document
          .querySelectorAll(".expandBtn")
          .forEach((b) => (b.style.display = "none"));
      } else {
        document
          .querySelectorAll(".modVendorFilterTitle")
          .forEach((b) => b.classList.add("open"));
        document
          .querySelectorAll(".modVendorFacets")
          .forEach((l) => l.classList.add("open"));
        document
          .querySelectorAll(".expandBtn")
          .forEach((b) => (b.style.display = "block"));
      }
    })
  );

  window.addEventListener("scroll", (e) => {
    if (window.innerWidth > 767) {
      return;
    }
    if (window.pageYOffset >= 141) {
      document.querySelector(".fixedMobileButton").classList.add("fixed");
    } else {
      document.querySelector(".fixedMobileButton").classList.remove("fixed");
    }
  });

  function slugify(string) {
    const a =
      "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
    const b =
      "aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");

    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  }

  function keysEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1),
      keys2 = Object.keys(obj2);
    return (
      keys1.length === keys2.length && keys1.every((key) => keys2.includes(key))
    );
  }

  function transformMake(make) {
    if (make === "Volkswagen") {
      return "VW";
    } else if (make === "Mercedes Benz") {
      return "Mercedes";
    } else if (make === "More") {
      return "";
    }
    return make;
  }

  function transformModel(listing) {
    if (listing.model === "Coupe") {
      return `${listing.series} Coupe`;
    } else if (listing.model === "Sportback") {
      return `${listing.series} Sportback`;
    }
    return listing.model;
  }
});